var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.data},scopedSlots:_vm._u([{key:"receiveAddress",fn:function(ref){
var row = ref.row;
var index = ref.index;
return _c('AddressList',{attrs:{"list":row.receiveAddress,"readonly":true,"noUpdate":true}})}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39266584","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wuliu/fahuo/chuhuozonglanChild.vue
// module id = null
// module chunks = 